// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"c369be0b","422":"137ce09a","464":"b554d76a","725":"f42a0de4"}[chunkId] + ".chunk.js";
};